import { ArrowDown, ArrowUp, Minus } from "lucide-react";
import { fruitLabel, fruits } from "@/data/fruits";

const emptyTrends = fruits.map((fruit) => ({ fruit: fruit.key, average: 0, latest: 0, change: 0 }));

const changeIconFor = (change) => {
  if (change > 0) return ArrowUp;
  if (change < 0) return ArrowDown;
  return Minus;
};

export const FruitCards = ({ trends = [] }) => {
  const visibleTrends = trends.length ? trends : emptyTrends;

  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="dashboard-fruit-card-grid">
      {visibleTrends.map((item, index) => {
        const ChangeIcon = changeIconFor(item.change);
        return (
          <article key={item.fruit} className="gentle-reveal rounded-2xl border border-[#E5E1D8] bg-white p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)]" style={{ animationDelay: `${index * 45}ms` }} data-testid={`fruit-card-${item.fruit}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-serif-display text-2xl font-semibold text-[#1A3626]" data-testid={`fruit-card-${item.fruit}-title`}>{fruitLabel(item.fruit)}</h3>
                <p className="mt-1 text-sm text-[#8C9B90]" data-testid={`fruit-card-${item.fruit}-latest`}>Latest: {item.latest || "—"}/5</p>
              </div>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F9F6F0] text-[#C87961]" data-testid={`fruit-card-${item.fruit}-change`}><ChangeIcon size={18} /></span>
            </div>
            <div className="mt-6 flex items-end justify-between" data-testid={`fruit-card-${item.fruit}-score-row`}>
              <p className="font-serif-display text-4xl font-semibold text-[#1A3626]" data-testid={`fruit-card-${item.fruit}-average`}>{Number(item.average || 0).toFixed(1)}</p>
              <p className="text-sm font-medium text-[#4A5D4E]" data-testid={`fruit-card-${item.fruit}-change-text`}>{item.change > 0 ? "+" : ""}{item.change} change</p>
            </div>
          </article>
        );
      })}
    </section>
  );
};